import React from 'react';
import PropTypes from 'prop-types';

const FlashcardIcon = ({color = 'currentColor', width = 20, height = 20, ...props}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2" y="6" width="16" height="12" rx="2" stroke={color} strokeWidth="1.5" />
    <path d="M6 6V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2" stroke={color} strokeWidth="1.5" />
    <line x1="6" y1="10" x2="14" y2="10" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="6" y1="13.5" x2="11" y2="13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

FlashcardIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default FlashcardIcon;
